import React, { useState, useEffect } from "react";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    setName("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
  }, []);

  return (
    <section className="pb-7">
      <div className="flex flex-col md:flex-row h-auto md:h-[800px] lg:h-[580px] bg-gray-100">
        {/* Left Section (Register Form) */}
        <div className="w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center items-center px-6 sm:px-8 md:px-12 py-12 bg-white mx-auto">
          <h1 className="text-3xl font-bold brand">FILAMEN</h1>
          <h2 className="text-[12px] font-semibold mb-5 mt-3">Create Your Account 🚀</h2>
          <p className="text-gray-500 text-xs sm:text-sm md:text-base mb-6 text-center">
            Enter your details to get started.
          </p>

          <form autoComplete="off" className="w-full">
            {/* Name Input */}
            <div className="w-full mb-4">
              <input
                type="text"
                name="no-autofill-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Full Name"
                autoComplete="off"
                className="w-full border-b-2 sm:border-b-4 border-black focus:outline-none placeholder-black p-2 sm:p-3 text-sm sm:text-base"
              />
            </div>

            {/* Email Input */}
            <div className="w-full mb-4">
              <input
                type="email"
                name="no-autofill-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                autoComplete="off"
                className="w-full border-b-2 sm:border-b-4 border-black focus:outline-none placeholder-black p-2 sm:p-3 text-sm sm:text-base"
              />
            </div>

            {/* Password Input */}
            <div className="w-full mb-2">
              <input
                type="password"
                name="no-autofill-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                autoComplete="new-password"
                className="w-full border-b-2 sm:border-b-4 border-black focus:outline-none placeholder-black p-2 sm:p-3 text-sm sm:text-base"
              />
            </div>

            {/* Confirm Password Input */}
            <div className="w-full mb-6">
              <input
                type="password"
                name="no-autofill-confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                autoComplete="off"
                className="w-full border-b-2 sm:border-b-4 border-black focus:outline-none placeholder-black p-2 sm:p-3 text-sm sm:text-base"
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-black text-white py-3 rounded-lg font-semibold transition-transform duration-200 hover:bg-gray-900 hover:scale-105"
            >
              Sign Up
            </button>

            {/* Already Have an Account */}
            <p className="text-gray-600 text-xs sm:text-sm mt-4 text-center">
              Already have an account?{" "}
              <a href="/login" className="text-black font-semibold hover:underline">
                Log in
              </a>
            </p>
          </form>
        </div>

        {/* Right Section (Image) */}
        <div className="w-full md:w-1/2 lg:w-2/3 flex justify-center items-center overflow-hidden">
          <img
            className="w-full h-full object-cover"
            src="/FILAMEN%282%29.png"
            alt="Register Illustration"
          />
        </div>
      </div>
    </section>
  );
};

export default Register;
